import { RouteRecordRaw } from 'vue-router'

const channelIntegrationRoute: RouteRecordRaw = {
  path: 'channel-integrations',
  name: 'ChannelIntegrations',
  component: () => import('./ChannelIntegrationListing.vue'),
  meta: {
    title: 'Channel Integrations'
  }
}

export default channelIntegrationRoute
